// The Reference Check tab's own words (lane B8 S13). The card, its fields, statuses and rules come from @/mc (G8's
// ReferenceCheck, REFERENCE_STATUS, RULE_LABELS); this module adds his access sentence for the HR seats' read-only
// view. The outcome and provider choices are configuration served with the check, never words written here.
import { defineLabels, type LabelDef, type LabelSource } from "@/mc/labels";

const his = <const S extends string>(text: S, source: LabelSource, quote: string) =>
  ({ text, source, quote, status: "his" }) as const satisfies LabelDef;

const ACCESS = "\"Recruiter manages. Authorized HR roles view. Candidate/interviewer access prohibited unless policy explicitly allows.\"";

export const REF_TAB_LABELS = /* @__PURE__ */ defineLabels({
  recruiterManages: his("Recruiter manages."),
  hrRolesView: his("Authorized HR roles view."),
});
